import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";
import {Tooltip} from "react-tooltip";
import React from "react";

const Username = ({user = null}) => {

	if (!user) return;

	return (
		<a href={user.view_url} title={user.username} className="username">
			<span className={`username--style${user.display_style_group_id}`}>{user.username}</span>

			<Tooltip id="username-tooltip" />

			{user.is_verified && (
				<FontAwesomeIcon
					icon={faCheckCircle}
					className="inline-block ml-2 text-url"
					data-tooltip-id="username-tooltip" data-tooltip-content={'Đã xác minh'}
				/>
			)}
		</a>
	);
}

export default Username;